import { FC, useEffect, useRef, useState } from "react";

export const withScroll = <T extends object>(ComposedComponent: FC<T & { scrollPosition: number }>) => {
  return function ScrollableComp(props: Omit<T, "scrollPosition">) {
    const [scrollPosition, setScrollPosition] = useState(getWindowScrollTop());
    const intervalIDRef = useRef<number | null>(null);
    const requestIDRef = useRef<number | null>(null);

    useEffect(() => {
      intervalIDRef.current = setInterval(handleInterval, 250);

      return () => {
        if (intervalIDRef.current) {
          clearInterval(intervalIDRef.current);
        }
        if (requestIDRef.current) {
          cancelAnimationFrame(requestIDRef.current);
        }
        intervalIDRef.current = null;
        requestIDRef.current = null;
      };
    }, []);

    function getWindowScrollTop() {
      return window.pageYOffset || document.documentElement.scrollTop;
    }

    function handleInterval() {
      if (requestIDRef.current) {
        cancelAnimationFrame(requestIDRef.current);
      }
      requestIDRef.current = requestAnimationFrame(handleRequestAnimationFrame);
    }

    function handleRequestAnimationFrame() {
      const newScrollPosition = getWindowScrollTop();
      setScrollPosition(newScrollPosition);
    }

    return <ComposedComponent {...(({ ...props, scrollPosition }) as T)} scrollPosition={scrollPosition} />;
  };
};
